import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import BasicInformationsTab from './BasicInformationsTab';
import BankAccountsTab from '../../modules/bankAccount/BankAccountsTab';
import DepartmentsTab from './DepartmentsTab';
import LogoAndStampTab from './LogoAndStampTab';


const BasicData = ({company}) => {

    const [activeTab, setActiveTab] = useState('BASIC_INFORMATIONS');
    const [t] = useTranslation();

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>{t('header.company.basicData')}</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/">{t('header.company.company')}</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    {t('header.company.basicData')}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row"></div>
                            <div className="col-12 col-sm-8 col-lg-8" style={{margin: '0 auto',float: 'none'}}>
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'BASIC_INFORMATIONS'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('BASIC_INFORMATIONS')
                                                    }
                                                >
                                                    {t('basicData.label.basicInformations')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'DEPARTMENTS'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('DEPARTMENTS')
                                                    }
                                                >
                                                    {t('basicData.label.departments')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'LOGO_AND_STAMP'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('LOGO_AND_STAMP')
                                                    }
                                                >
                                                    {t('basicData.label.logoAndStamp')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'BANK_ACCOUNTS'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('BANK_ACCOUNTS')
                                                    }
                                                >
                                                    {t('basicData.label.bankAccounts')}
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <BasicInformationsTab
                                                isActive={activeTab === 'BASIC_INFORMATIONS'}
                                               
                                            />                                           
                                            <DepartmentsTab
                                                isActive={activeTab === 'DEPARTMENTS'}
                                                
                                            />
                                            <LogoAndStampTab
                                                isActive={activeTab === 'LOGO_AND_STAMP'}
                                              
                                            />
                                            <BankAccountsTab
                                                isActive={activeTab === 'BANK_ACCOUNTS'}                                             
                                                entityId={company.id}
                                                entityName="company"
                                            />
                                        </div>
                                    </div>
                                </div>   
                            </div>                         
                </div>
            </section>
        </>
    );
};

const mapStateToProps = (state) => ({
    company: state.company.currentCompany
 });
 
 export default connect(mapStateToProps,null)(BasicData);